<script>
   /**************************************************************/
   /* Svelte component for VariancePlot settings                 */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';
   import PlotTypeSelector from '../../../shared/controls/PlotTypeSelector.svelte';

   export let params;
   export let res;

   let zoom = 'off';
   let varType = 'explained';
   let varForm = 'cumulative'
   let plotType = 'b';
   let showLabels = 'hide';

   $: params = {
      zoom,
      plotType,
      varType: (varType === 'explained' ? 'exp' : 'res'),
      varForm: (varForm === 'cumulative' ? 'cum' : ''),
      showLabels
   }
</script>

{#if res  }
<Container label="">
   <p class="title">Variance plot</p>
</Container>
<PlotTypeSelector bind:value={plotType} plotTypeOptions={['b', 'h']} />
<Container label='Type:'>
   <Select id='varType' bind:value={varType} options={['explained', 'residual']} />
</Container>
<Container label='Form:'>
   <Select id='varForm' bind:value={varForm} options={['individual', 'cumulative']} />
</Container>
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>
{/if}
